'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$00249 from "./presto.-Agent-View$$anon$9.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dClosed$0024 from "./presto.-Agent-View$-Closed$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$8() {
  this.aAk = null;
  this.aAc = null;
  this.aAd = false;
  this.aAl = null;
  this.aAm = false;
  this.aAp = null;
  this.aAi = null;
  this.aAj = false;
  this.aAe = null;
  this.aAf = false;
  this.aAg = null;
  this.aAh = false;
  this.aAn = false;
  this.aAo = false;
  this.aAk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aAp = "Closed";
}
export { $c_Lpresto_AgentView$$anon$8 as $c_Lpresto_AgentView$$anon$8 };
$p = $c_Lpresto_AgentView$$anon$8.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$8;
/** @constructor */
function $h_Lpresto_AgentView$$anon$8() {
}
export { $h_Lpresto_AgentView$$anon$8 as $h_Lpresto_AgentView$$anon$8 };
$h_Lpresto_AgentView$$anon$8.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.aAk;
});
$p.L = (function() {
  if ((!this.aAd)) {
    this.aAc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aAd = true;
  }
  return this.aAc;
});
$p.O = (function() {
  if ((!this.aAm)) {
    this.aAl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aAm = true;
  }
  return this.aAl;
});
$p.E = (function() {
  return this.aAp;
});
$p.t = (function() {
  if ((!this.aAj)) {
    this.aAi = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aAj = true;
  }
  return this.aAi;
});
$p.M = (function() {
  if ((!this.aAf)) {
    this.aAe = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.aAf = true;
  }
  return this.aAe;
});
$p.Q = (function() {
  if ((!this.aAh)) {
    this.aAg = new $j_presto$002e$002dAgent$002dView$0024$0024anon$00249.$c_Lpresto_AgentView$$anon$9();
    this.aAh = true;
  }
  return this.aAg;
});
$p.w = (function() {
  if ((!this.aAo)) {
    this.aAn = false;
    this.aAo = true;
  }
  return this.aAn;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee64) => ((p) => \u03b4scrutinee64))($j_presto$002e$002dAgent$002dView$0024$002dClosed$0024.$m_Lpresto_AgentView$Closed$())));
});
var $d_Lpresto_AgentView$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$8, "presto.AgentView$$anon$8", ({
  Ed: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$8 as $d_Lpresto_AgentView$$anon$8 };
//# sourceMappingURL=presto.-Agent-View$$anon$8.js.map
